import AgencySaleAddOrderScreen from 'features/Agency/screens/AgencySaleAddOrderScreen';
import AgencySaleDetailScreen from 'features/Agency/screens/AgencySaleDetailScreen';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import InvestorGroupDetailScreen from './screens/InvestorGroupDetailScreen';
import InvestorGroupListScreen from './screens/InvestorGroupListScreen';
import EditAgencyScreen from 'features/ManageDealer/screens/EditAgencyScreen';

ManageGroup.propTypes = {};

function ManageGroup(props) {
  const { isGroupInfo } = props;
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0 pb-4">
        <Routes>
          <Route path="" element={<InvestorGroupListScreen />} />
          <Route
            path={"/add"}
            element={<EditAgencyScreen agencyRole="GROUP" />}
          />
          <Route
            path="/:agencyId"
            element={<InvestorGroupDetailScreen isGroupInfo={isGroupInfo} />}
          />
          <Route
            path={'/:agencyId/edit'}
            element={<EditAgencyScreen agencyRole="GROUP" isEditUserAgency={true} />}
          />
          <Route path="/:agencyId/:saleId" element={<AgencySaleDetailScreen />} />
          <Route path="/:agencyId/sale/:saleId" element={<AgencySaleDetailScreen />} />
          <Route path="/group-info/:dealerId" element={<InvestorGroupDetailScreen />} />
          <Route path="/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
          <Route path="/:agencyId/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
          <Route path="*" element={<>Not found</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ManageGroup;
